import request from '@/utils/request'


// 创建订单
export function createOrder(params) {
    return request({
        url: '/api/order/confirmAll',
        method: 'post',
        data:params,
        isAuth: true,
    })
}

export function toAliPay(url, data) {
    return request({
        url: 'api/' + url,
        data: data,
        method: 'post'
    })
}
// 确认订单

export function confirmOrder(key,params) {
    alert(JSON.stringify(params));
    return;
    // return request({
    //     url: `/api/order/create/${key}`,
    //     method: 'post',
    //     data:params,
    //     isAuth: true,
    // })
}

// 订单列表
export function getOrderList(params) {
    return request({
        url: `/api/order/list`,
        method: 'get',
        params,
        isAuth: true,
    })
}

// 取消订单

export function cancelOrder(params) {
    return request({
        url: `/api/order/cancel`,
        method: 'post',
        data:params,
        isAuth: true,
    })
}

// 获取账号密码强弱
export function checkLogin(params) {
    return request({
        url: `/api/checkLogin`,
        method: 'post',
        data:params,
        isAuth: true,
    })
}